import React, { useState, forwardRef } from 'react';
import { DownloadIcon } from 'lucide-react';
import { toPng } from 'html-to-image';
import jsPDF from 'jspdf';
export const ExportButton = forwardRef<HTMLButtonElement>((props, ref) => {
  const [isExporting, setIsExporting] = useState(false);
  const handleExport = async () => {
    setIsExporting(true);
    try {
      const element = document.getElementById('roadmap-content');
      if (!element) return;
      const dataUrl = await toPng(element, {
        quality: 0.95,
        pixelRatio: 2
      });
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });
      const imgWidth = 210;
      const pageHeight = 297;
      const imgHeight = element.offsetHeight * imgWidth / element.offsetWidth;
      let heightLeft = imgHeight;
      let position = 0;
      pdf.addImage(dataUrl, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(dataUrl, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
      pdf.save('heliona-roadmap.pdf');
    } catch (error) {
      console.error('Export failed:', error);
    } finally {
      setIsExporting(false);
    }
  };
  return <button ref={ref} onClick={handleExport} disabled={isExporting} className="flex items-center justify-center gap-2 px-6 py-3 bg-white dark:bg-[#1A2332] text-[#1A2332] dark:text-white border-2 border-[#7FE5A8] rounded-xl font-semibold transition-all duration-200 shadow-lg hover:shadow-xl hover:bg-[#E8FAF1] dark:hover:bg-[#2A3F5F] disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-27">
      <DownloadIcon className="h-5 w-5" data-id="element-28" />
      {isExporting ? 'Exporting...' : 'Export PDF'}
    </button>;
});
ExportButton.displayName = 'ExportButton';